<template>
  <el-container  style="display: block;">
  <el-row style="width: 100%;margin-top: 20px;text-align: center;">
      <h2>指令库</h2>


  </el-row>
	<el-container class="lables">

		<el-row style="width: 90%;margin-top: 50px;">
			<el-col :span="6" class="first">
				<el-row>
					<div class="search">
						<input type="text" v-model="searchF" @change="loadData()"/>
					</div>
				</el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in lableFirst" :key="index">
					<div class="lable-o" :class="{'choses':choseAF.indexOf(item.l_id)>-1&&item.l_id!=choses,'chosess':item.l_id==choses}"  @click="chose(item.l_id)">
          {{item.name}}
          </div>

				</el-row>
			</el-col>
      <el-col :span="7" class="two">

      	<el-row class="lable-o-l">
      		<div v-for="(item,index) in lableTwo" style="position: relative;">
      		  <div class="lable-two"  :class="{'choses':choseAT.indexOf(item.id)>-1,'chosess':item.id==chosesh}" :key="index" @click="choseHy(item.id)">
      		  {{item.name}}
      		  </div>

      		</div>

      	</el-row>
      </el-col>
			<el-col :span="7" class="two">
				<el-row>
					<div class="search">
						<input type="text"  v-model="searchT" @change="loadDataHy()"/>
					</div>
					<div>
            <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
            <el-button type="primary" style="background-color: #409eff;" @click="delAll()" round>一键删除</el-button>
          </div>

        </el-row>
				<el-row class="lable-o-l">
					<div v-for="(item,index) in lableThree" style="position: relative;">
					  <div class="lable-two"  :class="{'choses':choseAT.indexOf(item.id)>-1}" :key="index" @click="lableC(item.id,item.name)">
					  {{item.name}}
					  </div>
					  <i @click="del(item.id)"  style="position: absolute;right: -20px;bottom: 5px;">X</i>
					</div>
          <el-pagination
            @size-change="loadDataHy()"
            @current-change="loadDataHy()"
            :current-page.sync="page"
            :page-size="20"
            background
            layout="total,prev, pager, next, jumper"
            :total="count">
          </el-pagination>
				</el-row>
			</el-col>
      <el-col :span="4" class="two">
      	<el-row>
          <h2>一键转移当前回应</h2>

        </el-row>
      	<el-row class="lable-o-l">
      		<div v-for="(item,index) in bases" style="position: relative;">
      		  <div class="lable-two"   @click="zhuanyi(item.bname)">
      		  {{item.name}}
      		  </div>

      		</div>

      	</el-row>
      </el-col>
		</el-row>

	</el-container>
	 <el-dialog
	  title="添加"
	  :visible.sync="centerDialogVisible"
	  width="40%"
	  center>
    <el-input
      type="textarea"
      :rows="20"
      style="height: 500px;"
      placeholder="请输入内容"
      v-model="addT">
    </el-input>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>
  <el-dialog
    title="修改"
    :visible.sync="xiugaiDialogVisible"
    width="30%"
    center>
    <input type="text" v-focus="picFocusStatus" @input="changeInput()" class="searchTsx" v-model="addc"/>

    <span slot="footer" class="dialog-footer">
  	<el-button @click="xiugaiDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doChange()">确 定</el-button>
    </span>
  </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        lableFirst:[],
        lableTwo:[],
        lableThree:[],
        chosesT:0,
        choses:0,
        chosesh:0,
        count:0,
        page:1,
		choseAF:[],
		choseAT:[],
		searchF:'',
		searchT:'',
    addc:'',
		lable:[],
		lableEx:'',
    xiugaiDialogVisible:false,
		centerDialogVisible:false,
		addType:0,
		picFocusStatus:false,
		addT:'',
		dialogVisible: false,
		acp:'',
		addcf:0,
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl,
    bases:[]
      };
    },
	directives: {
		focus: {
		  inserted: function(el, { value }) {
			if (value) {
			  el.focus();
			}
		  }
		}
    },
    created() {
		//var cip = returnCitySN["cip"];
// 		if(this.$store.getters.getRole != 'admins'){
// 				   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 					   this.$router.push({ path: '/' })
// 				   }
// 		}
if(!window.localStorage.getItem('id')){
      this.$router.push({ path: '/' })
    }
       this.loadData();


    },

	methods:{
    zhuanyi(basename){
      if(this.choses == 0 || this.chosesh == 0){
        this.msg('请选择','error');
        return false
      }

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	params:{
      		lid:this.choses,
          pid:this.chosesh,
          basesname:basename
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/bczhuanyizl'
      })
      .then(res=>{
      	this.msg('修改成功','success');
        this.xiugaiDialogVisible = false
        this.loadDataHy()

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF,
          b_id:1
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/keyFirstbczl'
			})
			.then(res=>{
				this.lableFirst = res.data.data;
        this.bases = res.data.bases;
			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{

					p_id:this.choses
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/fuzhiHYzl'
			})
			.then(res=>{
				this.lableTwo = res.data;
        this.count = res.data.length
			})
			.catch(err=>{

			});
		},
    loadDataHy(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          p:this.page,
          name:this.searchT,
    			p_id:this.chosesh
    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/fuzhiHYlistzl'
    	})
    	.then(res=>{
    		this.lableThree = res.data.list;
        this.count = res.data.count;
    	})
    	.catch(err=>{

    	});
    },
    del(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/fuzhiDelzl'
      })
      .then(res=>{
      	this.msg('删除成功','success');
        this.loadDataHy()

      })
      .catch(err=>{

      });
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	params:{
      		id:this.chosesT,
          name:this.addc
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/fuzhiChangezl'
      })
      .then(res=>{
      	this.msg('修改成功','success');
        this.xiugaiDialogVisible = false
        this.loadDataHy()

      })
      .catch(err=>{

      });
    },
    delAll(){
      if(this.choses>0&&this.chosesh>0){
        const axiosInstance = this.$axios.create({
        	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
        });

        axiosInstance({
        	method:'post',
        	params:{
        		pid:this.chosesh,
        	},
        	url:'http://fencip.yoooooo.com/index.php/index/data/fuzhiDelszl'
        })
        .then(res=>{
        	this.msg('删除成功','success');
          this.loadDataHy()

        })
        .catch(err=>{

        });
      }else{
        this.msg('请选择功能及回应','error')
      }

    },
		chose(id){
			this.choses = id;
			this.searchT = '';
			this.loadDataTwo();

		},
    choseHy(id){
    	this.chosesh = id;
    	this.loadDataHy();

    },
		lableC(id,name){
      this.addc = name;
      this.chosesT = id;
      this.xiugaiDialogVisible = true
		},

		add(){
      if(this.choses>0&&this.chosesh>0){
        this.centerDialogVisible = true
      }else{
        this.msg('请选择功能及回应','error')
      }


		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},

		doAdd(){
      var data = this.addT.split('\n')
      var huiying = data.join(',')
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          lid:this.choses,
          pid:this.chosesh,
          names:huiying
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/fuzhiAddszl'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.centerDialogVisible = false
          this.msg('添加成功','success');
          this.loadDataHy()
        }else{
          this.msg('添加失败','error');


        }



      })
      .catch(err=>{

      });

		}
	}


  }
</script>

<style>


	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/zhiling.vue